import script from "./OwnerLink.vue?vue&type=script&setup=true&lang=js"
export * from "./OwnerLink.vue?vue&type=script&setup=true&lang=js"

import "./OwnerLink.vue?vue&type=style&index=0&id=2598c05c&lang=css"

const __exports__ = script;

export default __exports__